import { render } from "./TopTwoTop50.vue?vue&type=template&id=cf6371c6&scoped=true&ts=true"
import script from "./TopTwoTop50.vue?vue&type=script&lang=ts"
export * from "./TopTwoTop50.vue?vue&type=script&lang=ts"

import "./TopTwoTop50.vue?vue&type=style&index=0&id=cf6371c6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf6371c6"]])

export default __exports__